import React from 'react';

const Hero: React.FC = () => {

  return (
    <section
      className="w-full h-[8rem] sm:h-[20rem] md:h-[25rem] lg:h-[30rem] mt-[7.5rem] sm:mt-[6rem] md:mt-[7rem] lg:mt-[12rem] bg-center bg-cover bg-no-repeat flex items-center"
      style={{ 
        backgroundImage: "url('/banner-u888-dai-le-30-4.webp')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
    </section>
  );
};

export default Hero; 